<template>
  <div>
    <div class="p-0 m-0">
      <b-form-input
        v-model="xValue"
        :state="(xValue === '' && intercpValue === '') || (xValue !== '' && !isNaN(xValue))"
        aria-describedby="input-live-help input-live-feedback"
        placeholder="X"
        trim
        size="sm"
        @change="updateCoefficients"
      />
      <b-form-invalid-feedback class="input-live-feedback">
        If one variable is defined. All inputs must have a valid value
      </b-form-invalid-feedback>
    </div>
    <div class="p-0 m-0">
      <b-form-input
        v-model="intercpValue"
        :state="(intercpValue === '' && xValue === '') || (intercpValue !== '' && !isNaN(intercpValue))"
        aria-describedby="input-live-help input-live-feedback"
        placeholder="(Intercept)"
        trim
        size="sm"
        @change="updateCoefficients"
      />
      <b-form-invalid-feedback class="input-live-feedback">
        If one variable is defined. All inputs must have a valid value
      </b-form-invalid-feedback>
    </div>
    <TextInputConfiguration
      :controller="DilutionCtrller"
      :sizeinput="'sm'"
      :forcerow="false"
    />
  </div>
</template>

<script>
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import {hiddenConfCtrller, inputTextConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapActions } from 'vuex'

const zoneNotify = 'FitDoubleLogModel'

export default {
  name: 'DoubleLog',
  components:{
    TextInputConfiguration
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    },
    fitname:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      xValue:'',
      intercpValue:'',
      elementsConfig:[],
      customCoefs: new hiddenConfCtrller(`${ConfigName.BaseCurveFit}.{0}.CustomCoefs`,[]),
      DilutionCtrller:new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.{0}.DilutionFactor`,'Dilution factor','Please provide a valid Dilution Factor','1',(value)=>{return value !==''}),
      initializing:false
    }
  },
  async mounted(){
    this.elementsConfig = [
      this.customCoefs,
      this.DilutionCtrller
    ]
    //Delay the initialization so it can read the most updated values
    await this.$nextTick()
    await this.$nextTick()
    await this.$nextTick()
    try{
      this.initializing = true
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.formatKeyValue(this.fitname))
      this.elementsConfig.forEach(conf=>conf.setParent(this))
      if(this.customCoefs.value.length === 2){
        this.xValue = this.customCoefs.value[0]
        this.intercpValue = this.customCoefs.value[1]
      }else{
        this.xValue = ''
        this.intercpValue = ''
      }
    }catch{
      const infoTitle='DoubleLog Fit Error'
      const infoText='The report stored in the system has different structure. Please contact your administrator.'
      this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO,infoTitle,infoText,zoneNotify)
    }finally{
      this.initializing = false
    }
  },
  methods:{
    ...mapActions(['setConfigReportModifiedReportViewer']),
    updateCoefficients(){
      if(this.initializing){
        return
      }
      if(this.xValue === '' || isNaN(this.xValue) || this.intercpValue === '' || isNaN(this.intercpValue)){
        this.customCoefs.setValue([])
      }else{
        this.customCoefs.setValue([parseFloat(this.xValue), parseFloat(this.intercpValue)])
      }
      this.setConfigReportModifiedReportViewer()
    }
  }
}
</script>

<style>

</style>